import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { TranslatePipe } from '@ngx-translate/core';
import { SectionTitleComponent } from '../../../components/section-title/section-title.component';
import { DEPLOYMENT_SERVICES, SERVICE_HEALTH } from '../../models/devops-mock.data';
import { DeploymentStageCardComponent } from './deployment-stage-card.component';
import { ServiceHealthRowComponent } from './service-health-row.component';

@Component({
  selector: 'app-devops-pipeline-health',
  imports: [MatIcon, TranslatePipe, SectionTitleComponent, DeploymentStageCardComponent, ServiceHealthRowComponent],
  templateUrl: './devops-pipeline-health.component.html',
  styleUrl: './devops-pipeline-health.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DevOpsPipelineHealthComponent {
  protected readonly services = DEPLOYMENT_SERVICES;
  protected readonly health = SERVICE_HEALTH;
}
